import VerificationPage from './verification-page'
export default VerificationPage;